import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-demande-service-header",
  templateUrl: "./demande-service-header.component.html",
  styleUrls: ["./demande-service-header.component.scss"],
})
export class DemandeServiceHeaderComponent {
  @Input() title = "";
  @Input() domain = "";

  @Output() backPressed = new EventEmitter<void>();
  @Output() closePressed = new EventEmitter<void>();
}
